import React, { Component } from "react";
import { Pagination, PaginationItem, PaginationLink, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './index.css';
import ProgressBar from "../../../_components/common/ProgressBar";
import Options from "./Options";
import { connect } from 'react-redux';
import { respondentsAssessmentAction, onSubmitAssessmentAction } from "../../../_actions";
import swal from "sweetalert2";
import SweetAlert from "sweetalert2-react/lib/SweetAlert";
import Stopwatch from '../../../images/Stopwatch.svg';
import Honesty from '../../../images/Honesty.svg';
import Neutral from '../../../images/Neutral.svg';


class SingleRater extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pageNo: 1,
      paginationLength: null,
      questions: '',
      intervalId: 0,
      questionAnswered: 0,
      questionCount: 0,
      questionId: null,
      optionId: null,
      scrollTop: 'display-none ',
      loading: null,
      assessmentDetails: null,
      infoModal: true,
      optionIndex: null,
      showSwal: false,
      answerSummary: 'false',
    }
  }


  componentWillMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidMount() {
   

    this.reformatData(this.props.data.questions_list);

  }

 
  getQuestions(pageNo, count, data) {
    let questions = [];
    const start = (pageNo - 1) * count;
    const end = start + count - 1;
    for (let i = start; i <= end; i++) {
      if (i < data.length) {
        questions.push(data[i])
      }
    }
    return questions;
  }



  handleScroll = () => {
    const top = window.pageYOffset;
    if (top > 50) {
      this.setState({
        scrollTop: " display-inline "
      })
    }
    else {
      this.setState({
        scrollTop: " display-none "
      })
    }
  }

  infoToggle = () => {
    this.setState({ infoModal: false })
  }

  scrollStep() {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - 50);
  }

  scrollToTop() {
    let intervalId = setInterval(this.scrollStep.bind(this), 16.66);
    this.setState({ intervalId: intervalId });
  }

 
  reformatData(data) {
    let assessmentDetails = null;
    for (let i in this.props.assessment) {
      if (this.props.assessment[i].id === +this.props.id) {
        assessmentDetails = this.props.assessment[i]
      }
    }

    const questions = [];
    for (let i in data) {
      const num = (+i + 1)
      data[i].slNo = +num
    }
    this.questionCount(data);
  
    this.setState({
      questions: this.getQuestions(1, this.props.data.instument.no_of_question_in_page, data),
      paginationLength: Math.ceil(data.length / this.props.data.instument.no_of_question_in_page),
      assessmentDetails: assessmentDetails
    });
  }


  onSelectOption(optionData,qId, oId, index, optionIndex) {

    this.setState({
      questionId: qId,
      optionId: optionData.id,
      loading: index,
      optionIndex: optionIndex,
    })


    let questionsUpdated = this.state.questions;
    let questionAnswered = this.state.questionAnswered;
    let qIdFound = false
    for (let i in questionsUpdated) {
      if (questionsUpdated[i].id === qId) {
        if (Object.keys(questionsUpdated[i].user_response).length === 0 || questionsUpdated[i].user_response.assessment_option_id !== oId) {
          
          qIdFound = true

          const data = {
            "organisation": this.state.assessmentDetails.organisation,
            "user_assessment": this.state.assessmentDetails.id,
            "assessment_option": oId,
            "user": this.state.assessmentDetails.participant__id,
            "assessment_question": qId,
            "start_value": optionData.option_start_value,
            "end_value": optionData.option_end_value,
            "assessment_value": optionData.option_end_value,
            "seller": this.state.assessmentDetails.seller,
            "is_participant": true,
          }

          this.props.dispatch(respondentsAssessmentAction.respondentsAssessmentHandler(data, this.state.assessmentDetails, (resp_data_api) => {
            this.setState({
              questionAnswered: resp_data_api.data.assessment_completed_count,
              loading: null
            })
          }))
        }
      }

    }
    if(!qIdFound) {
      this.setState({
        loading: null
      })
    }
    this.setState({
      questions: questionsUpdated,
    })
  
  }

  // this method is used to count the questions
  questionCount(data) {
    let questionAnswered = 0;
    if (data.length != 0) {
      for (let i in data) {
        if (Object.keys(data[i].user_response).length !== 0
        ) {
          questionAnswered = questionAnswered + 1;
        }
      }
    }
    this.setState({
      questionCount: data.length,
      questionAnswered: questionAnswered,
    })
  }

  // This method is used to update the pageNo and Questions
  onClickPagination(value) {
    this.setState({
      pageNo: value,
      questions: this.getQuestions(value, this.props.data.instument.no_of_question_in_page, this.props.data.questions_list)
    })

  }

  // This method is used to increment the pagination and update the questions
  onClickNext = () => {
    if (this.state.pageNo === this.state.paginationLength) {
      this.setState({
        pageNo: 1,
        questions: this.getQuestions(1, this.props.data.instument.no_of_question_in_page, this.props.data.questions_list)
      })
    }
    else {
      this.setState({
        pageNo: this.state.pageNo + 1,
        questions: this.getQuestions(this.state.pageNo + 1, this.props.data.instument.no_of_question_in_page, this.props.data.questions_list)
      })
    }
  }

  // this method is used to check whether all questions are submitted 
  isPageFilled = (pageNo) => {
    const getQuestions = this.getQuestions(pageNo, this.props.data.instument.no_of_question_in_page, this.props.data.questions_list);
    let isFilled = true;
    for (let i in getQuestions) {
      if (Object.keys(getQuestions[i].user_response).length === 0) {
        isFilled = false
      }
    }
    if (!isFilled) {
      return false
    }
    else {
      return true
    }
  }

  // this method returns the pagination UI
  pagination = (paginationLength) => {
    const data = []
    for (let i = 1; i <= paginationLength; i++) {
      data.push(<PaginationItem key={i} className={(this.isPageFilled(i) === true ? " custom-navigation " : " ") + (this.state.pageNo === i ? ' active' : '')}>
        <PaginationLink className="py-1 px-4" onClick={() => this.onClickPagination(i)}>
          {i}
        </PaginationLink>
      </PaginationItem >)
    }
    return data
  }

  // This method is used to update the answers after the backend response
  updateData = () => {
    const questionsUpdated = this.state.questions;
    let questionAnswered = this.state.questionAnswered
    for (let i in questionsUpdated) {
      if (questionsUpdated[i].id === this.state.questionId) {
        if (Object.keys(questionsUpdated[i].user_response).length === 0 && questionsUpdated[i].user_response.constructor === Object) {
          questionAnswered = questionAnswered + 1;
         
        }
        const addObj = {
          'assessment_option_id': this.state.optionId,
          'assessment_value': this.state.optionId,
          'optionIndex': this.state.optionIndex,
        };
        questionsUpdated[i].user_response = addObj
      }
    }
    
  }

  // this method is used to submit the whole assessment
  onClickSubmit = () => {
  

    swal({
      text: 'Are you sure want to submit assessment?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!'
    }).then((result) => {
      if (result.value) {
        const data = {
          "user_assessment": this.state.assessmentDetails.id,
          "user": this.state.assessmentDetails.participant__id
        }
       
        this.props.dispatch(onSubmitAssessmentAction.onSubmitAssessmentHandler(data, this.state.assessmentDetails, this.callQuestionAgain));
        this.setState({ showSwal: true })
      }
    });
  }
  clearHistory = () => {
    window.location.replace('/app/dashBoard')
  }

  callQuestionAgain = () => {
  }

  onClickEditAssessment = () => {
    this.setState({ answerSummary: 'false' })
  }


  render() {
    (this.props.respondentsAssessmentStatus === 200 || this.props.respondentsAssessmentStatus === 201) && !this.props.respondentsAssessmentLoading ? this.updateData() : '';

    const { answerSummary } = this.state;
    const { assessmentResponse } = this.props;

  
    return (
      <div>
        {
          this.state.assessmentDetails !== null &&
          this.state.assessmentDetails.assessment_status__status_name === 'Yet to start' &&
          <Modal
            isOpen={this.state.infoModal}
            centered={true}
            style={{ maxWidth: '1000px' }}>
            <ModalBody>
              <div className="d-flex flex-row">
                <div className="col-1 px-0">
                </div>
                <div className="col-10 px-0">
                  <div className="d-flex flex-row flex-wrap justify-content-between">
                    <div>
                      <h3>Things to keep in mind</h3>
                    </div>
                    <div>
                      <button onClick={this.infoToggle} className="btn-red text-white btn-sm text-uppercase " type="submit">Begin Questionnaire</button>
                    </div>
                  </div>
                  <div className="py-5  d-flex flex-row flex-wrap justify-content-center">
                    <div className="col-12 col-md-4 px-0">
                      <div className="d-flex flex-row flex-wrap justify-content-center">
                        <div className="col-12 text-center mb-2 px-0">
                          <span className="fa-stack fa-2x">
                            <i className="fas fa-circle text-secondary"></i>
                            <span style={{ fontSize: '16px' }} className="fa-stack-1x text-white">1</span>
                          </span>
                        </div>
                        <div className="col-12 text-center px-0">
                          <img style={{ width: '35%' }} className="img-fluid" src={Stopwatch} />
                        </div>
                        <div className="col-12 mt-2 text-center px-1 text-muted">
                          <p style={{ fontSize: '16px' }}>Respond to all the questions in one go.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-4 px-0">
                      <div className="d-flex flex-row flex-wrap justify-content-center">
                        <div className="col-12 text-center mb-2 px-0">
                          <span className="fa-stack fa-2x">
                            <i className="fas fa-circle text-secondary"></i>
                            <span style={{ fontSize: '16px' }} className="fa-stack-1x text-white">2</span>
                          </span>
                        </div>
                        <div className="col-12 text-center px-0">
                          <img style={{ width: '35%' }} className="img-fluid" src={Honesty} />
                        </div>
                        <div className="col-12 mt-2 text-center px-1 text-muted">
                          <p style={{ fontSize: '16px' }}>Be honest in your responses.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-4 px-0">
                      <div className="d-flex flex-row flex-wrap justify-content-center">
                        <div className="col-12 text-center mb-2 px-0">
                          <span className="fa-stack fa-2x">
                            <i className="fas fa-circle text-secondary"></i>
                            <span style={{ fontSize: '16px' }} className="fa-stack-1x text-white">3</span>
                          </span>
                        </div>
                        <div className="col-12 text-center px-0">
                          <img style={{ width: '44%' }} className="img-fluid" src={Neutral} />
                        </div>
                        <div className="col-12 mt-2 text-center px-1 text-muted">
                          <p style={{ fontSize: '16px' }}>Do not leave any response neutral</p>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
                <div className="col-1">
                </div>
              </div>

            </ModalBody>
          </Modal>

        }
        {
          <div>
            < div className="container custom-container my-5" >
              <div className="custom-padding">
                {
                  answerSummary === 'false' &&
                  this.state.questions !== '' &&
                  this.state.questions.map(
                    (data, i) => {
                      return <div key={i}>
                        <Options index={i} slNo={i + 1} loading={this.state.loading} data={data} onSelectOption={( data, qId, oId, index, optionIndex ) => { this.onSelectOption(data,qId, oId, index, optionIndex) }} />
                      </div>
                    }
                  )
                }
               
               
                {
                  answerSummary === 'true' &&
                  this.state.questions.map(
                    (data, j) => {
                      for (let i in assessmentResponse.instument.instrument_options) {
                       

                        if (data.user_response.assessment_option_id === assessmentResponse.instument.instrument_options[i].id) {
                          const option = "option-" + (assessmentResponse.instument.instrument_options[i].option_order-1);
                          return (<React.Fragment key={j}>
                            <p >{data.slNo}. {data.user_questions.question_statement_self}</p>
                            <div className={option + " col-6 col-md-4 custom-top-option  cursor-pointer text-white text-center ml-3 animation-fade-in"} style={{ borderRadius: '11px' }}>{assessmentResponse.instument.instrument_options.map(
                              (response, k) => {
                                return (
                                  response.id === data.user_response.assessment_option_id &&
                                  <small key={k} className={"font-weight-bold animation-fade-in animation-fade-in"}>{response.option_name}</small>
                                )
                              }
                            )}</div>

                            <hr style={{ borderColor: 'grey' }} />
                          </React.Fragment>)
                        }

                      }

                    })
                }
              </div>
              <div className="paginator-footer bg-white">
                <div className="d-flex flex-row flex-nowrap">
                  {
                    answerSummary === 'false' &&
                    <div className="col-6 py-3 d-none  d-md-block animation-fade-in">

                      <React.Fragment>
                       
                        <ProgressBar key={this.state.questionAnswered} max={this.state.questionCount} value={this.state.questionAnswered} striped={false}
                        height={false} />
                      </React.Fragment>
                    </div>
                  }
                  {
                    answerSummary === 'true' &&
                    <div className="col-4 py-3 d-none  d-md-block">
                      <p>This assessment is complete</p>
                    </div>
                  }

                  <div className="col-sm-6 col-md-3 py-2">
                    <Pagination className="custom-pagination animation-fade-in" size="sm" aria-label="Page navigation">
                      {
                        this.pagination(Math.ceil(this.props.data.questions_list.length / this.props.data.instument.no_of_question_in_page))
                      }
                    </Pagination>
                  </div>

                  <div className="fa-2x py-1 px-lg-3 px-1 col-md-1 col-sm-2 animation-fade-in" >
                    <i onClick={this.onClickNext} className="fas fa-arrow-circle-right cursor-pointer"></i>
                  </div>
                  {
                    answerSummary === 'false' &&

                    <div className="col-md-2 col-4 py-2 pl-0 animation-fade-in">
                      {
                        this.state.questionCount == this.state.questionAnswered ?
                        <Button onClick={this.onClickSubmit} className={`px-lg-4 px-2 btn-red`} size="sm" style={{color: "white"}}>SUBMIT</Button> :
                        <Button disabled={this.state.questionCount !== this.state.questionAnswered} onClick={this.onClickSubmit} className={`px-lg-4 px-2 btn-white`} size="sm" outline style={{color: "black"}}>SUBMIT</Button>
                      }
                    </div>
                  }
                  {
                    answerSummary === 'true' &&
                    <div className="col-md-2 col-6 py-2 pl-0 animation-fade-in">
                      <Button onClick={this.clearHistory} className="px-lg-4 px-2 buttonColor" size="sm">GO TO DASHBOARD</Button>

                    </div>
                  }
                </div>
              </div>
            </div >

            <div className={' scrolltop bg-success d-none  d-md-block animation-fade-in'}>
              <div className='scroll icon'>
                <i onClick={() => { this.scrollToTop(); }} className={this.state.scrollTop + " fas fa-2x fa-arrow-circle-up"}></i>
              </div>
            </div>

          </div>

        }

        {
          (this.props.submitAssessmentResponse === 200 || this.props.submitAssessmentResponse === 201) &&
          <SweetAlert
            show={this.state.showSwal}
            text={"Assessment submitted Successfully"}
            type='success'
            showCancelButton={true}
            confirmButtonColor='#EE6452'
            cancelButtonColor='#EE6452'
            cancelButtonText='Selected Answers'
            confirmButtonText='Go to dashboard'
            onConfirm={() => {
             
              window.location.replace('/app/dashBoard')
              this.setState({ showSwal: false })
          
            }}
            onCancel={() => {
           
              this.setState({ answerSummary: 'true', showSwal: false })
            }}
          />
        }
      </div>

    );
  }
}

function mapStateToProps(state) {

  const { respondentsAssessmentLoading } = state.respondentsAssessmentReducer;
  const respondentsAssessmentStatus = (!respondentsAssessmentLoading) ? state.respondentsAssessmentReducer.data.status : '';

  const { submitAssessmentLoading } = state.submitSingleRaterAssessment;
  const submitAssessmentResponse = (!submitAssessmentLoading) ? state.submitSingleRaterAssessment.data.status : '';

  const { getAssessmentLoading } = state.getAssessmentList;
  const getAssessmentError = state.getAssessmentList.error;
  const assessmentResponse = (!getAssessmentLoading && !getAssessmentError) ? state.getAssessmentList.data.data : '';
  return {
    respondentsAssessmentLoading,
    respondentsAssessmentStatus,
    submitAssessmentResponse,

    getAssessmentLoading,
    getAssessmentError,
    assessmentResponse,
  };
}

export default connect(mapStateToProps)(SingleRater);



// WEBPACK FOOTER //
// ./src/_pages/Assessments/SingleRater/index.jsx